module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-gray-back"
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit
    }
  }, [_c('van-divider', [_vm._v("基础配置")]), _vm._v(" "), _c('van-field', {
    attrs: {
      "input-align": "right",
      "name": "配置名称",
      "label": "配置名称",
      "placeholder": "配置名称",
      "rules": [{
        required: true,
        message: '请填写配置名称'
      }]
    },
    model: {
      value: (_vm.formData.title),
      callback: function($$v) {
        _vm.$set(_vm.formData, "title", $$v)
      },
      expression: "formData.title"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "选择日期区间",
      "readonly": "",
      "placeholder": "选择日期区间",
      "rules": [{
        required: true,
        message: '请选择日期区间'
      }],
      "input-align": "right"
    },
    on: {
      "click": function($event) {
        _vm.show = true
      }
    },
    model: {
      value: (_vm.formData.data_time),
      callback: function($$v) {
        _vm.$set(_vm.formData, "data_time", $$v)
      },
      expression: "formData.data_time"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "input-align": "right",
      "name": "团队人数",
      "label": "团队人数",
      "placeholder": "团队人数",
      "rules": [{
        required: true,
        message: '请填写团队人数'
      }]
    },
    model: {
      value: (_vm.formData.complete_count),
      callback: function($$v) {
        _vm.$set(_vm.formData, "complete_count", $$v)
      },
      expression: "formData.complete_count"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "input-align": "right",
      "name": "购买时限",
      "label": "购买时限",
      "placeholder": "购买时限(小时)",
      "rules": [{
        required: true,
        message: '请填写购买时限'
      }]
    },
    model: {
      value: (_vm.formData.time_limit),
      callback: function($$v) {
        _vm.$set(_vm.formData, "time_limit", $$v)
      },
      expression: "formData.time_limit"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "switch",
      "label": "上架状态",
      "input-align": "right"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-switch', {
          attrs: {
            "size": "20"
          },
          model: {
            value: (_vm.formData.status),
            callback: function($$v) {
              _vm.$set(_vm.formData, "status", $$v)
            },
            expression: "formData.status"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "switch",
      "label": "是否包邮",
      "input-align": "right"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-switch', {
          attrs: {
            "size": "20"
          },
          model: {
            value: (_vm.formData.express_free_status),
            callback: function($$v) {
              _vm.$set(_vm.formData, "express_free_status", $$v)
            },
            expression: "formData.express_free_status"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('van-divider', [_vm._v("地址配置")]), _vm._v(" "), _c('van-field', {
    attrs: {
      "input-align": "right",
      "label": "收件人",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formData.express_user_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "express_user_name", $$v)
      },
      expression: "formData.express_user_name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "input-align": "right",
      "label": "手机号",
      "type": "number",
      "placeholder": "请输入手机"
    },
    model: {
      value: (_vm.formData.express_user_phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "express_user_phone", $$v)
      },
      expression: "formData.express_user_phone"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "input-align": "right",
      "readonly": "",
      "value": _vm.formData.express_province +
        _vm.formData.express_city +
        _vm.formData.express_county,
      "label": "地区",
      "placeholder": "请选择地区"
    },
    on: {
      "click": function($event) {
        _vm.area_show = true
      }
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "input-align": "right",
      "label": "详细地址",
      "placeholder": "请输入详细地址"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "16px"
    }
  }, [_c('van-button', {
    attrs: {
      "round": "",
      "block": "",
      "type": "info",
      "native-type": "submit"
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.area_show),
      expression: "area_show"
    }],
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "z-index": "1000",
      "width": "100%"
    }
  }, [_c('van-popup', {
    staticStyle: {
      "top": "50%"
    },
    attrs: {
      "position": "bottom",
      "close-on-click-overlay": false
    },
    model: {
      value: (_vm.area_show),
      callback: function($$v) {
        _vm.area_show = $$v
      },
      expression: "area_show"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.formData.area_key
    },
    on: {
      "confirm": _vm.areaConfirm,
      "cancel": _vm.areaCancel
    }
  })], 1)], 1), _vm._v(" "), _c('van-calendar', {
    attrs: {
      "type": "range"
    },
    on: {
      "confirm": _vm.onConfirm
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-932e8db8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/configure/ConfigureAdd.vue
// module id = 2544
// module chunks = 0